'use client';

import { c as _c } from "react/compiler-runtime";
import type { LiveItem } from '@module/apis/client-side/live/type';
import MainTitle from '@pc/components/atoms/typograph/MainTitle';
import BroadcastList from '@pc/components/molecules/broadcast/BroadcastList';
import BroadcastListSkeleton from '@pc/components/molecules/broadcast/BroadcastListSkeleton';
import type { ReactNode } from 'react';
interface Props {
  dataTestId: string;
  title: string;
  list?: LiveItem[];
  isLoading: boolean;
  isFetching: boolean;
  isFetched: boolean;
  listLength: 12 | 15;
  titleAction?: ReactNode;
}
export interface MainSectionProps {
  isLoading: boolean;
  isFetching: boolean;
  isFetched: boolean;
  currentScreenSize: 'md' | 'lg' | 'xl';
  listLength: 12 | 15;
}
function MainBroadcastSection(t0) {
  const $ = _c(11);
  const {
    dataTestId,
    title,
    list,
    isLoading,
    isFetching,
    isFetched,
    listLength,
    titleAction
  } = t0;
  if (isFetched && !list?.length) {
    return null;
  }
  const shouldShowSkeleton = isLoading || isFetching || list === undefined;
  let t1;
  if ($[0] !== title || $[1] !== titleAction) {
    t1 = titleAction ? <div className="flex items-start gap-2"><MainTitle>{title}</MainTitle>{titleAction}</div> : <MainTitle>{title}</MainTitle>;
    $[0] = title;
    $[1] = titleAction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== list || $[4] !== listLength || $[5] !== shouldShowSkeleton) {
    t2 = shouldShowSkeleton ? <BroadcastListSkeleton itemLength={listLength} /> : <BroadcastList list={list} />;
    $[3] = list;
    $[4] = listLength;
    $[5] = shouldShowSkeleton;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== dataTestId || $[8] !== t1 || $[9] !== t2) {
    t3 = <div className="mb-10" data-testid={dataTestId}>{t1}{t2}</div>;
    $[7] = dataTestId;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export default MainBroadcastSection;